class Common {
  _init = async () => {
    return true
  }

  async setTvWindowSize() {
    return true
  }
}

export default Common
